<div class="header">
  <app-title
    [title]="'Protocolos'"
    [subtitle]="'Configurar protocolos'"
  ></app-title>
  <div class="top restaurant">
    <div class="boton">
      <button
        class="b1"
        mat-button
        routerLink="/home/vacations/protocols/protocol/add"
      >
        Nuevo protocolo
      </button>
    </div>
  </div>

  <div class="header-cards">
    <div class="card">
      <div class="title">GRUPOS DE REGLAS</div>
      <div class="numbers">
        <span>{{ ruleGroups.length }}</span>
      </div>
    </div>

    <div class="card">
      <div class="title">PROTOCOLOS</div>
      <div class="numbers">
        <span>{{ protocols.length }}</span>
      </div>
    </div>

    <div class="card">
      <div class="title">OPERATIVAS</div>
      <div class="numbers">
        <span>{{ totalOperativas }}</span>
      </div>
    </div>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>

<div class="content">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedTabIndex">
    <mat-tab label="PROTOCOLOS">
      <div class="cards">
        @for(protocol of protocols; track protocol.id) {
        <app-protocol-card [protocol]="protocol" [ruleGroupCount]="getRuleGroupCountForProtocol(protocol.id)" [operativaCount]="getOperativaCountForProtocol(protocol.id)" (protocolCopied)="onProtocolCopied()"></app-protocol-card>
        }
      </div>
    </mat-tab>

    <mat-tab label="GRUPOS">
      <div class="cards rule-groups">
        @for(ruleGroup of ruleGroups; track ruleGroup.id) {
        <app-rule-group-card [ruleGroup]="ruleGroup"></app-rule-group-card>
        }
      </div>
    </mat-tab>

    <mat-tab label="REGLAS">
      <app-rules-list [rules]="rules" (ruleDeleted)="loadData()"></app-rules-list>
    </mat-tab>
  </mat-tab-group>
</div>
